import {
  IonAccordion,
  IonAccordionGroup,
  IonItem,
  IonLabel
} from "@ionic/react";
import HelpButton from "./HelpButton";

interface HelpData {
  [key: string]: {
    area: string;
    id: string;
    title: string;
    content: string;
  };
}

const HelpAccordion = ({ helpData }: { helpData: HelpData }) => {
  const groupedByArea: { [key: string]: any[] } = Object.entries(
    helpData
  ).reduce((acc: { [key: string]: any[] }, [key, value]) => {
    if (!acc[value.area]) acc[value.area] = [];
    acc[value.area].push({
      id: key,
      area: value.area,
      title: value.title,
      content: value.content
    });
    return acc;
  }, {});

  return (
    <IonAccordionGroup>
      {Object.entries(groupedByArea).map(([area, items], index) => (
        <IonAccordion key={index} value={area}>
          <IonItem slot="header">
            <IonLabel>{area}</IonLabel>
          </IonItem>
          <div className="ion-padding" slot="content">
            {items.map((item: any) => (
              <HelpButton key={item.id} id={item.id} title={item.title} />
            ))}
          </div>
        </IonAccordion>
      ))}
    </IonAccordionGroup>
  );
};

export default HelpAccordion;
